import { useLogger } from 'touchless-buying-components/hooks/useLogger';
import { useAppSelector } from '../reducers';
import { experimentByTreatmentKeySelector } from '../selectors/ExperimentSelectors';
import { SSBU_0004_TREATMENT_KEY, SSBU_0004_GROUP_PARAMETER_OPTIONS } from '../constants/experimentKeys';
import useIsEligibleForFreeToStarterTouchlessFlow from '../components/interstitial/hooks/useIsEligibleForFreeToStarterTouchlessFlow';
import { getIsAcceptanceTest } from '../utils/testUtils';
import { logExposure as logExperimentExposure } from '../utils/laboratoryClient';
const useIsCheckoutUIFreeToStarterEnabled = productConfigurations => {
  var _ssbu0004Experiment$p;
  const {
    logInfo
  } = useLogger();
  const ssbu0004Experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, SSBU_0004_TREATMENT_KEY));
  const isEligibleForFreeToStarterTouchlessFlow = useIsEligibleForFreeToStarterTouchlessFlow(productConfigurations);
  const isAcceptanceTest = getIsAcceptanceTest();
  const isExperimentInVariation = (ssbu0004Experiment === null || ssbu0004Experiment === void 0 || (_ssbu0004Experiment$p = ssbu0004Experiment.parameters) === null || _ssbu0004Experiment$p === void 0 ? void 0 : _ssbu0004Experiment$p.group) === SSBU_0004_GROUP_PARAMETER_OPTIONS.variation;
  const isCheckoutUIFreeToStarterEnabled = isExperimentInVariation && isEligibleForFreeToStarterTouchlessFlow && !isAcceptanceTest;
  const logExposure = () => {
    var _ssbu0004Experiment$p2;
    logInfo('SSBU-0004', `Exposure logged: ${ssbu0004Experiment === null || ssbu0004Experiment === void 0 || (_ssbu0004Experiment$p2 = ssbu0004Experiment.parameters) === null || _ssbu0004Experiment$p2 === void 0 ? void 0 : _ssbu0004Experiment$p2.group}`);
    logExperimentExposure(SSBU_0004_TREATMENT_KEY);
  };
  return {
    isCheckoutUIFreeToStarterEnabled,
    isInExperiment: isEligibleForFreeToStarterTouchlessFlow,
    logExposure
  };
};
export default useIsCheckoutUIFreeToStarterEnabled;